import { combineReducers } from "redux";
import masterdata from "./MasterReducer";

export default combineReducers({
  masterdata
});